import { ProductUid } from '@shared/product/related-products/domain/models/related-products.models';

const getArrColorIds = (productId: string, relatedsList: any): string[] => {
    const result: string[] = [];

    // biome-ignore lint/complexity/noForEach: <explanation>
    relatedsList.forEach(relpro => {
        if (relpro.product_id === productId) {
            result.push(relpro.uid.substring(relpro.uid.length - 3));
        }
    });

    return result;
};
export const florenProductsTransformer = (apiRelateds: any): ProductUid[] => {
    return apiRelateds.map((item: any) => {
        return {
            arrColorId: getArrColorIds(item.product_id, apiRelateds),
            product_id: item.product_id,
            provider: 'inditex',
            uid: item.uid,
        };
    });
};
